module.exports = __webpack_public_path__ + "font1.06489b91.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font1.png
// module id = LfDV
// module chunks = 0